import {
  CHF_MAX_AGE,
  CHF_MIN_AGE,
  CHF_BALANCE_S,
  CHF_BALANCE_E,
  CHF_MIN_SERVICES_COST,
  CHF_MAX_SERVICES_COST,
} from '@pages/Clients/ClientsList/constants/filterKeysAndIds';

import type { NClientsList } from '@pages/Clients/ClientsList/ClientsList.types';

export const calculateSelectedFiltersByClients = (
  twoObjectsByClients: NClientsList.ClientsFilterUnitValue[]
): number => {
  const defaultSelectedFiltersCount = 0;
  const excludedFiltersIndex = 0;
  const includedFiltersIndex = 1;
  let counter = defaultSelectedFiltersCount;

  const excludedFilters = twoObjectsByClients?.[excludedFiltersIndex];
  const includedFilters = twoObjectsByClients?.[includedFiltersIndex];
  const isEmptyLogicalGroup = !excludedFilters && !includedFilters;

  if (isEmptyLogicalGroup) {
    return defaultSelectedFiltersCount;
  }

  const getRangeSelection: NClientsList.GetRangeSelection = (
    startKey,
    endKey
  ) => {
    return (
      !!includedFilters[startKey] ||
      includedFilters[startKey] === 0 ||
      !!includedFilters[endKey] ||
      includedFilters[endKey] === 0
    );
  };

  const isGenderSelected = includedFilters.Gender;
  const areTagsSelected = excludedFilters.TagIds || includedFilters.TagIds;
  const isAgeSelected = getRangeSelection(CHF_MIN_AGE, CHF_MAX_AGE);
  const isBalanceSelected = getRangeSelection(CHF_BALANCE_S, CHF_BALANCE_E);
  const isBirthDateSelected =
    includedFilters.DateStart || includedFilters.DateEnd;
  const areSalesSelected = getRangeSelection(
    CHF_MIN_SERVICES_COST,
    CHF_MAX_SERVICES_COST
  );

  if (isGenderSelected) counter++;
  if (areTagsSelected) counter++;
  if (areSalesSelected) counter++;
  if (isBirthDateSelected) counter++;
  if (isAgeSelected) counter++;
  if (isBalanceSelected) counter++;

  return counter;
};
